import { Component } from '@angular/core';
import { AbstractControl, NgModel, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-validations',
  template: `
    <p>
      validations works!
    </p>
  `,
  styles: [
  ]
})
export abstract class ValidationsComponent {

  // ALLOW ALPHABETS ONLY 
  allowAlphabetsOnly(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End', ' '];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    const inputChar = event.key;
    const isAlphabet = /^[a-zA-Z]$/.test(inputChar);

    if (!isAlphabet) {
      event.preventDefault();
    }
  }


  allowNumbersOnly(event: KeyboardEvent): void {
    const inputChar = event.key;
    // Allow only numbers (0-9)
    const isNumber = /^[0-9]$/.test(inputChar);
    if (!isNumber) {
      event.preventDefault();
    }
  }
  
  amountValidator(event: KeyboardEvent, currentValue: string): void {
  const inputChar = event.key;

  // Allow navigation and control keys (backspace, arrows, etc.)
  if (
    ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(inputChar)
  ) {
    return;
  }

  // Allow one decimal point
  if (inputChar === '.') {
    if (currentValue.includes('.')) {
      event.preventDefault(); // Prevent second decimal
    }
    return;
  }

  // Allow digits only
  const isNumber = /^[0-9]$/.test(inputChar);
  if (!isNumber) {
    event.preventDefault();
  }
}


  noNumberValidation(event: KeyboardEvent): void {
    const inputChar = event.key;

    // Check if character is a digit
    const isNumber = /^[0-9]$/.test(inputChar);

    if (isNumber) {
      event.preventDefault(); // Block numeric input
    }
  }

  noSpecialCharValidation(event: KeyboardEvent): void {
    const inputChar = event.key;

    // Allow only letters (a-z, A-Z), numbers (0-9), and space
    const isValid = /^[a-zA-Z0-9\s]$/.test(inputChar);

    if (!isValid) {
      event.preventDefault(); // Block special characters
    }
  }


  //  date format
  dateFormatValidator(control: AbstractControl): ValidationErrors | null {
    const dateRegex = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    const value = control.value;
    return dateRegex.test(value) ? null : { invalidDateFormat: true };
  }

  // past date are not allowed
  pastDateValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const inputDate = new Date(value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);
    return inputDate < today ? { pastDate: true } : null;
  }



getDateValidationMessage(control: AbstractControl | NgModel): string | null {
/*
  for from controller use this in html
  ------------------------------------

  <small class="text-danger" *ngIf="getDateValidationMessage(myForm.get('DATE'))">
  {{ getDateValidationMessage(myForm.get('DATE')) }}
</small>

for ngModel binding use this in html
-------------------------------------

 <input type="date" [(ngModel)]="formData.DATE" #dateRef="ngModel" name="DATE" required />
<small class="text-danger" *ngIf="getDateValidationMessage(dateRef)">
  {{ getDateValidationMessage(dateRef) }}
</small>
*/
  const isTouched = (control as any).touched;
  const isDirty = (control as any).dirty;
  const errors = (control as any).errors;

  if (isTouched || isDirty) {
    if (errors?.['required']) {
      return 'Date is required.';
    } else if (errors?.['invalidDateFormat']) {
      return 'Date must be in DD-MM-YYYY format.';
    } else if (errors?.['pastDate']) {
      return 'Past dates are not allowed.';
    }
  }

  return null;
}



  //------------------------------------ [(ngModel)] validations -------------------------

  // Required filed for ng model  in hmtl add  <input required #userNameRef="ngModel"> <div *ngIf="isFieldInvalid(userNameRef)" >
  // to disable save and update button  [disabled]="roleNameRef.invalid"
  isFieldInvalid(field: NgModel): boolean {
    return field.invalid && (field.dirty || field.touched);
  }

  // prevent space at first postion  in html add <input (keydown)="preventLeadingSpace($event)">
  preventLeadingSpace(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;

    // If cursor is at position 0 and space is pressed, prevent it
    if (event.key === ' ' && input.selectionStart === 0) {
      event.preventDefault();
    }
  }




}
